export default __webpack_public_path__ + "static/mscertifiedapp-3f3c093502cf3d6ca6746a99e72b5d89.svg";